// ============================================
// Common UI Components
// ============================================

import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: any[]) {
  return twMerge(clsx(inputs));
}

export function formatDate(dateString: string | null | undefined): string {
  if (!dateString) return 'Never';
  return new Date(dateString).toLocaleString();
}

export function formatRelativeTime(dateString: string | null | undefined): string {
  if (!dateString) return 'Never';
  const date = new Date(dateString);
  const now = new Date();
  const diffMs = now.getTime() - date.getTime();
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);

  if (diffMins < 1) return 'Just now';
  if (diffMins < 60) return `${diffMins}m ago`;
  if (diffHours < 24) return `${diffHours}h ago`;
  if (diffDays < 7) return `${diffDays}d ago`;
  return date.toLocaleDateString();
}

export function getStatusBadge(status: string) {
  const styles: Record<string, string> = {
    active: 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400',
    completed: 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-400',
    stale: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-400',
    disqualified: 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400',
    new: 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300',
    qualifying: 'bg-purple-100 text-purple-800 dark:bg-purple-900/30 dark:text-purple-400',
    form_sent: 'bg-orange-100 text-orange-800 dark:bg-orange-900/30 dark:text-orange-400',
    form_verified: 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-400',
    running: 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-400',
    success: 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400',
    failed: 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400',
    idle: 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300',
  };
  return styles[status] || styles.idle;
}

export function getStageBadge(stage: string) {
  const labels: Record<string, string> = {
    new: 'New',
    qualifying: 'Qualifying',
    form_sent: 'Form Sent',
    form_verified: 'Form Verified',
    completed: 'Completed',
    stale: 'Stale',
    disqualified: 'Disqualified',
  };
  return labels[stage] || stage;
}